import React from "react";
import { connect } from "react-redux";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import eventAdvertise from "../../../store/actions/eventAdvertise";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Area,
} from "recharts";

function LineChartReport({ dataChartStateRedux, eventDataChart }) {
  const dataChart = [];
  for (const key in dataChartStateRedux) {
    dataChart.push({
      hour: helpersNumbers.toPersianNum(
        key.replace("-", " ").replace("00:00", "00").replace("59:59", "59")
      ),
      value: dataChartStateRedux[key],
    });
  }

  const customizedTooltip = ({ label, payload, active, chartType }) => {
    if (!active) {
      return <></>;
    }
    if (payload == undefined) {
      return <></>;
    }

    if (payload[0] == undefined) {
      return <></>;
    }

    return (
      <div className="card " id="box-details-line-chart" dir="rtl">
        <div className="card-body p-3">
          <div className="d-flex justify-content-between pb-3">
            <span className="pl-2">
              &nbsp;
              {
                eventAdvertise.eventAdvertisePersian[
                  eventDataChart.toUpperCase()
                ]
              }
              :
            </span>
            <span>{helpersNumbers.toPersianNum(payload[0].value)}</span>
          </div>
          <div className="d-flex justify-content-between ">
            <span className="pl-2">زمان : </span>
            <span className="pr-2">
              {label.replace(" ", " تا ").split(" ").reverse().join(" ")}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const customizeLabelYAxis = (value) => {
    return helpersNumbers.toPersianNum(value);
  };
  return (
    <div>
      <ResponsiveContainer width="100%" aspect={2}>
        <LineChart data={dataChart}>
          <CartesianGrid stroke="#7DBCFF" strokeDasharray="3 3" />
          <XAxis dataKey="hour" padding={{ left: 20, right: 20 }} />
          <YAxis tick={{ dx: -5 }} tickFormatter={customizeLabelYAxis} />
          <Tooltip content={customizedTooltip} />
          <Line type="monotone" dataKey="value" stroke="#7fdf64" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    dataChartStateRedux: state.reportCampaign.data_chart,
    eventDataChart: state.reportCampaign.event_data_chart,
  };
};

export default connect(mapStateToProps, null)(LineChartReport);
